import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box, SkeletonLinesBox } from './skeleton.styles.js';

var _excluded = ["children", "rounding", "width", "height"],
    _excluded2 = ["width", "height", "lines", "gap", "shortLastLine", "keyPrefix"],
    _excluded3 = ["size"];
var Skeleton = function Skeleton(props) {
  var children = props.children,
      _props$rounding = props.rounding,
      rounding = _props$rounding === void 0 ? 16 : _props$rounding,
      _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '100px' : _props$height,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React__default.createElement(Box, _extends({
    "aria-hidden": "true",
    rounding: rounding,
    width: width,
    height: height
  }, attrs), children);
};
var SkeletonLines = function SkeletonLines(props) {
  var _props$width2 = props.width,
      width = _props$width2 === void 0 ? '100%' : _props$width2,
      _props$height2 = props.height,
      height = _props$height2 === void 0 ? '8px' : _props$height2,
      _props$lines = props.lines,
      lines = _props$lines === void 0 ? 3 : _props$lines,
      _props$gap = props.gap,
      gap = _props$gap === void 0 ? 8 : _props$gap,
      shortLastLine = props.shortLastLine,
      _props$keyPrefix = props.keyPrefix,
      keyPrefix = _props$keyPrefix === void 0 ? '' : _props$keyPrefix,
      attrs = _objectWithoutPropertiesLoose(props, _excluded2);

  return /*#__PURE__*/React__default.createElement(SkeletonLinesBox, {
    gap: gap
  }, new Array(lines).fill(null).map(function (line, idx) {
    var isLastElement = lines === idx + 1;
    var lineWidth = isLastElement && shortLastLine ? "calc(" + width + " - 43%)" : width; // eslint-disable-next-line react/no-array-index-key

    return /*#__PURE__*/React__default.createElement(Skeleton, _extends({
      key: keyPrefix + " + " + idx,
      width: lineWidth,
      height: height
    }, attrs));
  }));
};
var SkeletonRound = function SkeletonRound(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? '100px' : _props$size,
      attrs = _objectWithoutPropertiesLoose(props, _excluded3);

  return /*#__PURE__*/React__default.createElement(Skeleton, _extends({
    width: size,
    height: size,
    rounding: "round"
  }, attrs));
};

export { Skeleton, SkeletonLines, SkeletonRound };
